const DAY_MS = 24 * 60 * 60 * 1000;

// Parse "YYYY-MM-DD" as a local date; new Date(str) would treat it as UTC and can shift the day.
const toLocalMidnight = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
  if (isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
};

// Clamp to month end so Aug 31 + 3 months is Nov 30, not Dec 1.
const addMonthsClamped = (date, months) => {
  const target = new Date(date.getFullYear(), date.getMonth() + months, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(date.getDate(), lastDay));
  return target;
};

// Probation is 3 months from joining (6 if extended). endDate is the first day after probation.
export const getProbationInfo = (joiningDate, probationExtended) => {
  const joinDate = toLocalMidnight(joiningDate);
  if (!joinDate) return { inProbation: false, endDate: null, joinDate: null, daysLeft: 0, extended: !!probationExtended };

  const endDate = addMonthsClamped(joinDate, probationExtended ? 6 : 3);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const inProbation = today < endDate;
  const daysLeft = inProbation ? Math.round((endDate - today) / DAY_MS) : 0;
  return { inProbation, endDate, joinDate, daysLeft, extended: !!probationExtended };
};
